import { Component, Event, EventEmitter, h, Listen, Prop, State, Watch } from '@stencil/core';
import classnames from 'classnames';
import { DropdownItem } from '../dropdown-list/dropdown-list';
import { SVGIcon } from '../icons/svg-icon';

/**
 * @slot loading-text - Will show the slotted item instead the loading animation
 */
@Component({
  tag: 'opti-nav-menu',
  styleUrl: 'opti-nav-menu.scss',
  shadow: true,
})
export class OptiNavMenu {
  @Prop()
  filterPlaceholder: string = 'Filter...';

  @Prop()
  loading: boolean = true;

  @Prop({ attribute: 'options', reflect: true })
  options: DropdownItem[];

  @Prop()
  selected: DropdownItem[];

  @Watch('selected')
  handleSelectedChanged(newSelections: any) {
    this.selectedOptions = newSelections;
  }

  @State() selectedOptions: DropdownItem[] = [];

  parentSelections: DropdownItem[] = [];

  @Event({
    eventName: 'opti-nav-menu-focusin',
    composed: true,
  })
  navMenuFocusIn: EventEmitter<EventTarget>;

  menuFocusInHandler(e) {
    this.navMenuFocusIn.emit(e.target);
  }

  @Listen('opti-dropdown-list-selection')
  onItemSelection(event: CustomEvent<DropdownItem>) {
    const selectedItem = event.detail;

    if (!selectedItem?.subItems?.length) {
      this.selectedOptions = [...this.parentSelections, event.detail];
      this.parentSelections = [];
    } else {
      this.parentSelections = [event.detail];
    }
  }

  constructor() {
    this.menuFocusInHandler = this.menuFocusInHandler.bind(this);
  }

  componentWillLoad() {
    if (this.selected) {
      this.selectedOptions = this.selected;
    }
  }

  selectionText = () => {
    let singleInstance = false;
    return this.selectedOptions?.reduce((previousValue, currentValue = { text: '' }) => {
      const { type, text, subItems } = currentValue;
      if (type === "organization") {
        return text;
      }
      if (type === "product" && subItems?.length === 1) {
        singleInstance = true;
        return text;
      }
      return previousValue && !singleInstance ? `${previousValue} (${text})` : type === "instance" ? previousValue : text;
    }, '');
  };

  render() {
    const dropdownInactive = this.loading || (this.options?.length === 1 && (!this.options[0].subItems || this.options[0].subItems?.length === 1));
    const dropdownClasses = classnames('dropdown', { 'dropdown--inactive': dropdownInactive });

    // Show default text if no options
    if (!(this.loading || this.options?.length)) {
      return (
        <span class="label">
          <slot name="default-text"></slot>
        </span>);
    }

    const arrow = (
      <span class="arrow">
        <SVGIcon name="angle-down"></SVGIcon>
      </span>
    );

    return (
      <div class={dropdownClasses} tabIndex={0} onFocusin={this.menuFocusInHandler}>
        {this.loading ? (
          <div class="label--loading"></div>
        ) : this.selected ? (
          <span class="label" title={this.selectionText()}>
            {this.selectionText()}
            {!dropdownInactive && arrow}
          </span>
        ) : (
          <span class="label">
            <slot name="default-text"></slot>
            {!dropdownInactive && arrow}
          </span>
        )}
        <dropdown-list class="menu" selected={this.selectedOptions?.map(o => o?.value)} items={this.options} filterPlaceholder={this.filterPlaceholder}></dropdown-list>
      </div>
    );
  }
}
